// extracted by mini-css-extract-plugin
export var blue = "_s-f";
export var brand = "_s-b";
export var darkGrey = "_s-e";
export var disabled = "_s-4";
export var disabledSubtle = "_s-5";
export var error = "_s-6";
export var green = "_s-g";
export var grey = "_s-d";
export var icon = "_s-0";
export var inherit = "_s-a";
export var lightGrey = "_s-c";
export var orange = "_s-i";
export var pink = "_s-k";
export var primary = "_s-1";
export var purple = "_s-l";
export var red = "_s-j";
export var secondary = "_s-2";
export var success = "_s-9";
export var tertiary = "_s-3";
export var warning = "_s-7";
export var warningSecondary = "_s-8";
export var white = "_s-m";
export var yellow = "_s-h";